import gql from 'graphql-tag';

export const TOGGLE_FEATURE = gql`
  mutation setFeature($where: FeatureSetInput!){
      setFeature(where:$where){
      key
    }
  }
`;
